import { Component } from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import classNames from 'classnames';
import {StoreContext} from "../../../stores/StoreLoader";

@observer
export default class TagFilters extends Component {
    static contextType = StoreContext;
    static propTypes = {
        tagId: PropTypes.number.isRequired,
        tagIndex: PropTypes.number.isRequired,
        numTags: PropTypes.number.isRequired,
    };

    onClick = () => {
        const { tagId } = this.props;
        this.context.gridStore.tagFilters.toggleFilter(tagId);
    };

    render() {
        const { tagId, numTags, tagIndex } = this.props;
        const {gridStore} = this.context;

        const tag = gridStore.tagFilters.filters.get(tagId);
        const isLastTag = tagIndex === numTags - 1;

        /*
        variations are:
            tag 1.
            tag 1 or tag 2.
            tag 1, tag 2, or tag 3.
         */
        let preText = ' ';
        if (numTags > 1 && isLastTag) {
            preText = ' or ';
        }

        let btnText = tag.name;

        let postText;
        if (isLastTag) {
            postText = '.';
        } else if (numTags > 2) {
            postText = ',';
        }

        const className = classNames(
            'sb-collection-filter-bar-tag',
            {
                'active': tag.active,
            }
        );

        return (
            <span>{preText}<button className={className} onClick={this.onClick}>{btnText}</button>{postText}</span>
        );
    }
}
